// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui_section__6qh3Z {
  position: relative;
  padding-block: var(--section-y);
  padding-inline: var(--gutter);
  font-family: var(--font-sans);
  color: var(--color-text);
  background: var(--color-paper);
  overflow: clip;
}
.ui_container__kJbtX {
  max-width: var(--container);
  margin-inline: auto;
}
.ui_tone-light__jgFhU {
  background: var(--color-paper);
}
.ui_tone-cloud__ZNZKR {
  background: var(--color-cloud);
}
.ui_tone-ink__48ys3 {
  background: var(--color-ink);
  color: var(--color-text-on-dark);
}

/* Intro */
.ui_intro__YM8EB {
  max-width: 46rem;
  margin-bottom: clamp(2rem, 1rem + 3vw, 4rem);
}
.ui_center__tURMe {
  margin-inline: auto;
  text-align: center;
}
.ui_eyebrow__EuHAC {
  margin: 0 0 var(--space-4);
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  font-weight: 700;
  color: var(--color-text-muted);
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.ui_eyebrow__EuHAC::before {
  content: "";
  width: 2rem;
  height: 2px;
  background: var(--color-accent);
  flex: none;
}
.ui_center__tURMe .ui_eyebrow__EuHAC {
  justify-content: center;
}
.ui_tone-ink__48ys3 .ui_eyebrow__EuHAC {
  color: var(--color-text-muted-on-dark);
}
.ui_title__x2AWU {
  margin: 0;
  font-size: var(--text-h2);
  line-height: var(--leading-heading);
  font-weight: 500;
  letter-spacing: var(--tracking-heading);
  text-wrap: balance;
}
.ui_lead__vrBbn {
  margin: var(--space-5) 0 0;
  font-size: var(--text-body-lg);
  line-height: var(--leading-body);
  color: var(--color-text-muted);
}
.ui_tone-ink__48ys3 .ui_lead__vrBbn {
  color: var(--color-text-muted-on-dark);
}

/* Buttons */
.ui_button__uBY7A {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  min-height: 3rem;
  padding: 0.8rem 1.6rem;
  border: 2px solid transparent;
  border-radius: var(--radius-pill);
  font-family: var(--font-sans);
  font-size: 0.975rem;
  font-weight: 700;
  line-height: 1.2;
  text-decoration: none;
  cursor: pointer;
  transition: background-color var(--dur-fast) ease,
    color var(--dur-fast) ease, border-color var(--dur-fast) ease,
    transform var(--dur-fast) var(--ease-out);
}
.ui_button__uBY7A:hover {
  transform: translateY(-2px);
}
/* Glossy gold: a light top edge, a soft gold glow and a shine that sweeps
   across on hover. */
.ui_primary__1LeiQ {
  position: relative;
  overflow: hidden;
  isolation: isolate;
  background: linear-gradient(180deg, #ffe44d 0%, var(--kur-gold) 48%, #f2c400 100%);
  color: #111;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.65), inset 0 -1px 0 rgba(120, 90, 0, 0.25),
    0 6px 18px -6px rgba(255, 200, 0, 0.55);
}
.ui_primary__1LeiQ::after {
  content: "";
  position: absolute;
  inset: -20% auto -20% -60%;
  width: 45%;
  z-index: -1;
  background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.7), transparent);
  transform: skewX(-20deg) translateX(0);
  transition: transform 0.75s var(--ease-out);
}
.ui_primary__1LeiQ:hover {
  background: linear-gradient(180deg, #ffe866 0%, #ffdc1a 48%, var(--kur-gold-hover) 100%);
  color: #111;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7), inset 0 -1px 0 rgba(120, 90, 0, 0.25),
    0 10px 26px -8px rgba(255, 200, 0, 0.7);
}
.ui_primary__1LeiQ:hover::after {
  transform: skewX(-20deg) translateX(420%);
}
/* Frosted glass on dark grounds. */
.ui_secondary__D12Uw.ui_on-dark__MC7R\\+ {
  border-color: rgba(255, 255, 255, 0.28);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.04));
  backdrop-filter: blur(10px);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);
  color: #fff;
}
.ui_secondary__D12Uw.ui_on-dark__MC7R\\+:hover {
  border-color: rgba(255, 255, 255, 0.6);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.08));
  color: #fff;
}
@media (prefers-reduced-motion: reduce) {
  .ui_primary__1LeiQ::after {
    display: none;
  }
}
.ui_secondary__D12Uw.ui_on-light__pDjFn {
  border-color: var(--color-ink);
  color: var(--color-ink);
}
.ui_secondary__D12Uw.ui_on-light__pDjFn:hover {
  background: var(--color-ink);
  color: #fff;
}
.ui_link__\\+bKMW {
  padding: 0.25rem 0;
  min-height: 0;
  border-radius: 0;
  border-bottom: 2px solid var(--color-accent);
  font-weight: 700;
}
.ui_link__\\+bKMW.ui_on-dark__MC7R\\+ {
  color: #fff;
}
.ui_link__\\+bKMW.ui_on-light__pDjFn {
  color: var(--color-ink);
}
.ui_link__\\+bKMW:hover {
  transform: none;
  border-bottom-color: currentColor;
}
.ui_arrow__i\\+Z0e {
  transition: transform var(--dur-fast) var(--ease-out);
}
.ui_link__\\+bKMW:hover .ui_arrow__i\\+Z0e {
  transform: translateX(4px);
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/UI/ui.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;EAChB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;AAChC;AACA;EACE,sCAAsC;AACxC;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,iCAAiC;EACjC,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf;;6CAE2C;AAC7C;AACA;EACE,2BAA2B;AAC7B;AACA;qBACqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kFAAkF;EAClF,WAAW;EACX;2CACyC;AAC3C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,WAAW;EACX,uFAAuF;EACvF,sCAAsC;EACtC,2CAA2C;AAC7C;AACA;EACE,wFAAwF;EACxF,WAAW;EACX;2CACyC;AAC3C;AACA;EACE,yCAAyC;AAC3C;AACA,mCAAmC;AACnC;EACE,uCAAuC;EACvC,yFAAyF;EAEzF,2BAA2B;EAC3B,mDAAmD;EACnD,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,wFAAwF;EACxF,WAAW;AACb;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,4CAA4C;EAC5C,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,qDAAqD;AACvD;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".section {\n  position: relative;\n  padding-block: var(--section-y);\n  padding-inline: var(--gutter);\n  font-family: var(--font-sans);\n  color: var(--color-text);\n  background: var(--color-paper);\n  overflow: clip;\n}\n.container {\n  max-width: var(--container);\n  margin-inline: auto;\n}\n.tone-light {\n  background: var(--color-paper);\n}\n.tone-cloud {\n  background: var(--color-cloud);\n}\n.tone-ink {\n  background: var(--color-ink);\n  color: var(--color-text-on-dark);\n}\n\n/* Intro */\n.intro {\n  max-width: 46rem;\n  margin-bottom: clamp(2rem, 1rem + 3vw, 4rem);\n}\n.center {\n  margin-inline: auto;\n  text-align: center;\n}\n.eyebrow {\n  margin: 0 0 var(--space-4);\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  font-weight: 700;\n  color: var(--color-text-muted);\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n.eyebrow::before {\n  content: \"\";\n  width: 2rem;\n  height: 2px;\n  background: var(--color-accent);\n  flex: none;\n}\n.center .eyebrow {\n  justify-content: center;\n}\n.tone-ink .eyebrow {\n  color: var(--color-text-muted-on-dark);\n}\n.title {\n  margin: 0;\n  font-size: var(--text-h2);\n  line-height: var(--leading-heading);\n  font-weight: 500;\n  letter-spacing: var(--tracking-heading);\n  text-wrap: balance;\n}\n.lead {\n  margin: var(--space-5) 0 0;\n  font-size: var(--text-body-lg);\n  line-height: var(--leading-body);\n  color: var(--color-text-muted);\n}\n.tone-ink .lead {\n  color: var(--color-text-muted-on-dark);\n}\n\n/* Buttons */\n.button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  min-height: 3rem;\n  padding: 0.8rem 1.6rem;\n  border: 2px solid transparent;\n  border-radius: var(--radius-pill);\n  font-family: var(--font-sans);\n  font-size: 0.975rem;\n  font-weight: 700;\n  line-height: 1.2;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background-color var(--dur-fast) ease,\n    color var(--dur-fast) ease, border-color var(--dur-fast) ease,\n    transform var(--dur-fast) var(--ease-out);\n}\n.button:hover {\n  transform: translateY(-2px);\n}\n/* Glossy gold: a light top edge, a soft gold glow and a shine that sweeps\n   across on hover. */\n.primary {\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n  background: linear-gradient(180deg, #ffe44d 0%, var(--kur-gold) 48%, #f2c400 100%);\n  color: #111;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.65), inset 0 -1px 0 rgba(120, 90, 0, 0.25),\n    0 6px 18px -6px rgba(255, 200, 0, 0.55);\n}\n.primary::after {\n  content: \"\";\n  position: absolute;\n  inset: -20% auto -20% -60%;\n  width: 45%;\n  z-index: -1;\n  background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.7), transparent);\n  transform: skewX(-20deg) translateX(0);\n  transition: transform 0.75s var(--ease-out);\n}\n.primary:hover {\n  background: linear-gradient(180deg, #ffe866 0%, #ffdc1a 48%, var(--kur-gold-hover) 100%);\n  color: #111;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7), inset 0 -1px 0 rgba(120, 90, 0, 0.25),\n    0 10px 26px -8px rgba(255, 200, 0, 0.7);\n}\n.primary:hover::after {\n  transform: skewX(-20deg) translateX(420%);\n}\n/* Frosted glass on dark grounds. */\n.secondary.on-dark {\n  border-color: rgba(255, 255, 255, 0.28);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.04));\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);\n  color: #fff;\n}\n.secondary.on-dark:hover {\n  border-color: rgba(255, 255, 255, 0.6);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.08));\n  color: #fff;\n}\n@media (prefers-reduced-motion: reduce) {\n  .primary::after {\n    display: none;\n  }\n}\n.secondary.on-light {\n  border-color: var(--color-ink);\n  color: var(--color-ink);\n}\n.secondary.on-light:hover {\n  background: var(--color-ink);\n  color: #fff;\n}\n.link {\n  padding: 0.25rem 0;\n  min-height: 0;\n  border-radius: 0;\n  border-bottom: 2px solid var(--color-accent);\n  font-weight: 700;\n}\n.link.on-dark {\n  color: #fff;\n}\n.link.on-light {\n  color: var(--color-ink);\n}\n.link:hover {\n  transform: none;\n  border-bottom-color: currentColor;\n}\n.arrow {\n  transition: transform var(--dur-fast) var(--ease-out);\n}\n.link:hover .arrow {\n  transform: translateX(4px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `ui_section__6qh3Z`,
	"container": `ui_container__kJbtX`,
	"tone-light": `ui_tone-light__jgFhU`,
	"tone-cloud": `ui_tone-cloud__ZNZKR`,
	"tone-ink": `ui_tone-ink__48ys3`,
	"intro": `ui_intro__YM8EB`,
	"center": `ui_center__tURMe`,
	"eyebrow": `ui_eyebrow__EuHAC`,
	"title": `ui_title__x2AWU`,
	"lead": `ui_lead__vrBbn`,
	"button": `ui_button__uBY7A`,
	"primary": `ui_primary__1LeiQ`,
	"secondary": `ui_secondary__D12Uw`,
	"on-dark": `ui_on-dark__MC7R+`,
	"on-light": `ui_on-light__pDjFn`,
	"link": `ui_link__+bKMW`,
	"arrow": `ui_arrow__i+Z0e`
};
export default ___CSS_LOADER_EXPORT___;
